import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { styles } from "./qaStyles";
import { acquireQaFocus, releaseQaFocus } from "../../utils/qa/qaFocusBridge";

// Lightweight portal dialog, deliberately NOT the MUI CustomModal: no focus trap and
// no scroll lock, so already-open popovers survive for the stash-capture flow, and
// the whole tree unmounts instantly while a native capture is in flight. The root is
// tagged data-qa-exclude so outside-click handlers ignore clicks inside it.
// Backdrop clicks do NOT close it - a draft must never be lost to a stray click.
const QaPortalModal = ({ open, width, children }) => {
  // While the dialog is open, relax any underlying MUI modal's focus trap so the
  // dialog inputs can hold focus (e.g. opened over the Create Campaign modal).
  useEffect(() => {
    if (!open) return undefined;
    acquireQaFocus();
    return () => releaseQaFocus();
  }, [open]);

  if (!open) return null;
  return ReactDOM.createPortal(
    <div style={styles.overlay} data-qa-exclude="true">
      <div style={{ ...styles.dialog, ...(width ? { width } : {}) }} role="dialog" aria-modal="true">
        {children}
      </div>
    </div>,
    document.body
  );
};

export default QaPortalModal;
